module.exports = __webpack_public_path__ + "static/media/Gas Stove cock.a6df2c79.svg";